export class IntercomConfig {
  appId: string;
}
